import "./StepIcon.html";
import "./StepIcon.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { StepIconComponentController } from "./StepIconComponentController";

export class StepIconComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.controller = StepIconComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/StepIcon/StepIcon.html";
        this.transclude = true;
    }
}
